import React, {useContext, useEffect, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {FormLabel, TextField, FormControlLabel, Checkbox} from "@material-ui/core";
import {BackendContext} from "./BackendContext";
import {Save} from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import Swal from "sweetalert2";
import {inputStyles} from "../shared";
import Grid from "@material-ui/core/Grid";
import {WPMedia} from "./WPMedia";
import {Attachment} from "../SharedTypes";
import NumberFormat from "react-number-format";


const useStyles = makeStyles(theme => ({
    container: {
        margin: 'auto',
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
    },
    input: inputStyles
}));

function AdminEmailOptions() {
    const [notificationEmail, setNotificationEmail] = useState(""),
        [title, setTitle] = useState(""),
        [shippingOrigin, setShippingOrigin] = useState(""),
        [pricePerMile, setPricePerMile] = useState(0),
        [logo, setLogo] = useState<Attachment | undefined>(),
        [zipTaxKey, setZipTaxKey] = useState(""),
        [availableOptionsTitle, setAvailableOptionsTitle] = useState(""),
        [showAllOptionValues, setShowAllOptionValues] = useState(false),
        backendApiClient = useContext(BackendContext),
        classes = useStyles();
    useEffect(() => {
        backendApiClient.getSettings().then(settings => {
            setNotificationEmail(settings.notificationEmail);
            setTitle(settings.title);
            setLogo(settings.logo);
            setShippingOrigin(settings.shippingOrigin);
            setPricePerMile(settings.pricePerMile);
            setZipTaxKey(settings.zipTaxKey || '');
            setAvailableOptionsTitle(settings.availableOptionsTitle || '');
            setShowAllOptionValues(settings.showAllOptionValues || false)
        });
    }, [backendApiClient])
    return (
        <Paper className={classes.container}>
            <Typography component="h1" variant="h4" gutterBottom>Options</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField label="Notification Email" value={notificationEmail} className={classes.input}
                               onChange={e => setNotificationEmail(e.target.value)}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Shipping Origin" value={shippingOrigin} className={classes.input}
                               onChange={e => setShippingOrigin(e.target.value)}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <NumberFormat id="perPerMile" label="Price Per Shipping Mile"
                                  value={pricePerMile} className={classes.input}
                                  thousandSeparator prefix="$"
                                  customInput={TextField} decimalScale={0} min={0}
                                  onValueChange={e => setPricePerMile(e.floatValue || 0)}
                                  helperText="Used to estimate shipping"/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Zip Tax API Key" value={zipTaxKey} className={classes.input}
                               onChange={e => setZipTaxKey(e.target.value)}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Builder/Project Name" value={title} className={classes.input}
                               onChange={e => setTitle(e.target.value)}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Available Options Label" value={availableOptionsTitle} className={classes.input}
                               onChange={e => setAvailableOptionsTitle(e.target.value)}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div style={{maxWidth: 380}}>
                        <FormLabel style={{display: 'block', marginBottom: '1rem'}}>Builder/Project Image</FormLabel>
                        <WPMedia label="Builder/Project Image" attachment={logo}
                                 onChange={newValue => setLogo(newValue)}/>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControlLabel control={<Checkbox checked={showAllOptionValues} color="primary"
                                                         onChange={e => setShowAllOptionValues(e.target.checked)}/>}
                                      label="Show All Option Values"/>
                </Grid>
                <Grid item xs={12}>
                    <Button startIcon={<Save/>} variant="contained" color="primary" onClick={async () => {
                        await backendApiClient.saveSettings({
                            notificationEmail, title, logo, shippingOrigin,
                            pricePerMile, zipTaxKey, availableOptionsTitle,
                            showAllOptionValues
                        });
                        await Swal.fire({
                            title: 'Success',
                            text: 'the settings have been saved',
                            icon: 'success',
                        });
                    }}>Save</Button>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default AdminEmailOptions;